/* Le carnet de lecture.
 *
 * - La lecture est un fichier JSON déposé dans les Fichiers Shopify par le pipeline.
 * - Le jeton est long et aléatoire : personne ne peut tomber sur la lecture d'une autre.
 * - Les trois cartes se retournent une par une, puis restent en constellation en haut.
 * - Le nom et le chiffre des cartes sont écrits en HTML, jamais dans l'image.
 */
(function () {
  'use strict';

  var racine = document.querySelector('[data-ml]');
  if (!racine) return;

  var config = { base: '', dos: '', arcanes: '', pierres: '', boutique: '' };
  var brut = document.getElementById('ml-data');
  if (brut) { try { config = JSON.parse(brut.textContent); } catch (e) { /* défauts */ } }

  var CHAPITRES = [
    { cle: 'reponse', titre: 'Votre réponse' },
    { cle: 'cartes', titre: 'Les trois cartes' },
    { cle: 'suite', titre: 'Et maintenant ?' },
    { cle: 'rituel', titre: 'Votre rituel' },
    { cle: 'pierre', titre: 'Votre pierre' }
  ];

  var ecrans = {
    chargement: racine.querySelector('[data-ml-chargement]'),
    erreur: racine.querySelector('[data-ml-erreur]'),
    accueil: racine.querySelector('[data-ml-accueil]'),
    lecture: racine.querySelector('[data-ml-lecture]')
  };

  function $(sel) { return racine.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(racine.querySelectorAll(sel)); }
  function texte(el, valeur) { if (el) el.textContent = valeur || ''; }

  function montrer(nom) {
    Object.keys(ecrans).forEach(function (cle) {
      if (ecrans[cle]) ecrans[cle].hidden = (cle !== nom);
    });
  }

  // En JavaScript un tableau vide vaut vrai. Sans ce test, une formule sans rituel ni
  // domaines afficherait des titres suivis de rien.
  function rempli(valeur) {
    if (Array.isArray(valeur)) return valeur.some(function (m) { return String(m).trim(); });
    return Boolean(valeur && String(valeur).trim());
  }

  function paragraphes(conteneur, valeur) {
    if (!conteneur) return;
    conteneur.innerHTML = '';
    var morceaux = Array.isArray(valeur) ? valeur : String(valeur || '').split(/\n\s*\n/);
    morceaux.forEach(function (m) {
      if (!String(m).trim()) return;
      var p = document.createElement('p');
      p.textContent = String(m).trim();
      conteneur.appendChild(p);
    });
  }

  function visuelArcane(carte) {
    if (!config.arcanes || !carte.fichier) return '';
    return config.arcanes.replace('__NOM__', carte.fichier);
  }

  function allerA(element) {
    if (!element) return;
    if (element.scrollIntoView) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // --------------------------------------------- les cartes à retourner
  function poserCartes(cartes) {
    var rang = $('[data-ml-rang]');
    if (!rang) return;
    rang.innerHTML = '';
    cartes.forEach(function (carte) {
      var el = document.createElement('div');
      el.className = 'ml-carte';

      var dos = document.createElement('div');
      dos.className = 'ml-dos';
      if (config.dos) {
        var img = document.createElement('img');
        img.src = config.dos;
        img.alt = '';
        dos.appendChild(img);
      }

      var face = document.createElement('div');
      face.className = 'ml-face';
      var url = visuelArcane(carte);
      if (url) {
        var visuel = document.createElement('img');
        visuel.className = 'ml-visuel';
        visuel.src = url;
        visuel.alt = '';
        face.appendChild(visuel);
      }
      var romain = document.createElement('span');
      romain.className = 'ml-romain';
      romain.textContent = carte.romain || '';
      face.appendChild(romain);
      if (!url) {
        var glyphe = document.createElement('span');
        glyphe.className = 'ml-glyphe';
        face.appendChild(glyphe);
      }
      var nom = document.createElement('span');
      nom.className = 'ml-nom';
      nom.textContent = carte.nom || '';
      face.appendChild(nom);

      el.appendChild(dos);
      el.appendChild(face);
      rang.appendChild(el);
    });
  }

  function retourner(surFin) {
    var cartes = racine.querySelectorAll('.ml-rang .ml-carte');
    var i = 0;
    (function suivante() {
      if (i >= cartes.length) {
        window.setTimeout(surFin, 800);
        return;
      }
      cartes[i].classList.add('est-retournee');
      i += 1;
      window.setTimeout(suivante, 900);
    })();
  }

  // ------------------------------------------------- constellation
  function poserMinis(cartes) {
    var zone = $('[data-ml-minis]');
    if (!zone) return;
    zone.innerHTML = '';
    cartes.forEach(function (carte, index) {
      var bouton = document.createElement('button');
      bouton.type = 'button';
      bouton.className = 'ml-mini';
      var url = visuelArcane(carte) || config.dos;
      if (url) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        bouton.appendChild(img);
      }
      var nom = document.createElement('span');
      nom.textContent = carte.nom || '';
      bouton.appendChild(nom);
      bouton.addEventListener('click', function () {
        allerA(racine.querySelector('[data-ml-fiche="' + index + '"]'));
      });
      zone.appendChild(bouton);
    });

    // Le bouton PDF vit dans le bandeau collant : disponible à tout moment,
    // sans avoir à descendre jusqu'au bas de la lecture.
    var pdf = document.createElement('button');
    pdf.type = 'button';
    pdf.className = 'ml-pdf';
    pdf.setAttribute('data-ml-action', 'imprimer');
    pdf.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">'
      + '<path d="M12 3v11m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="2" '
      + 'stroke-linecap="round" stroke-linejoin="round"/>'
      + '<path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" '
      + 'stroke-width="2" stroke-linecap="round"/></svg><span>Garder en PDF</span>';
    pdf.addEventListener('click', function () { window.print(); });
    zone.appendChild(pdf);
  }

  // ------------------------------------------------- les trois fiches
  function poserFiches(cartes) {
    var zone = $('[data-ml-fiches]');
    if (!zone) return;
    zone.innerHTML = '';
    cartes.forEach(function (carte, index) {
      var bloc = document.createElement('div');
      bloc.className = 'ml-fiche';
      bloc.setAttribute('data-ml-fiche', String(index));

      var cadre = document.createElement('div');
      cadre.className = 'ml-fiche-visuel';
      var url = visuelArcane(carte) || config.dos;
      if (url) {
        var img = document.createElement('img');
        img.src = url;
        img.alt = carte.nom || '';
        img.loading = 'lazy';
        cadre.appendChild(img);
      }

      var entete = document.createElement('div');
      entete.className = 'ml-fiche-entete';
      var rang = document.createElement('p');
      rang.className = 'ml-fiche-rang';
      var pastille = document.createElement('b');
      pastille.textContent = String(index + 1);
      rang.appendChild(pastille);
      if (carte.romain) rang.appendChild(document.createTextNode('Arcane ' + carte.romain));
      var titre = document.createElement('h3');
      titre.textContent = carte.nom || '';
      var cle = document.createElement('p');
      cle.className = 'ml-cle';
      cle.textContent = carte.cle || '';
      entete.appendChild(rang);
      entete.appendChild(titre);
      entete.appendChild(cle);

      var zoneTexte = document.createElement('div');
      zoneTexte.className = 'ml-fiche-texte';
      paragraphes(zoneTexte, carte.texte);

      bloc.appendChild(cadre);
      bloc.appendChild(entete);
      bloc.appendChild(zoneTexte);
      zone.appendChild(bloc);
    });
  }

  // ------------------------------------------- sommaire et progression
  function chapitresVisibles() {
    return CHAPITRES.filter(function (ch) {
      var el = racine.querySelector('[data-ml-chapitre="' + ch.cle + '"]');
      return el && el.offsetParent !== null;
    });
  }

  function poserNavigation() {
    var visibles = chapitresVisibles();

    var liste = $('[data-ml-sommaire-liste]');
    if (liste) {
      liste.innerHTML = '';
      visibles.forEach(function (ch, i) {
        var li = document.createElement('li');
        li.setAttribute('data-ml-nav', ch.cle);
        var bouton = document.createElement('button');
        bouton.type = 'button';
        bouton.textContent = ('0' + (i + 1)) + ' — ' + ch.titre;
        bouton.addEventListener('click', function () {
          allerA(racine.querySelector('[data-ml-chapitre="' + ch.cle + '"]'));
        });
        li.appendChild(bouton);
        liste.appendChild(li);
      });
    }

    var suite = $('[data-ml-suite]');
    var suiteListe = $('[data-ml-suite-liste]');
    if (suite && suiteListe) {
      var apres = visibles.slice(1);
      if (apres.length) {
        suiteListe.innerHTML = '';
        apres.forEach(function (ch) {
          var li = document.createElement('li');
          var bouton = document.createElement('button');
          bouton.type = 'button';
          bouton.innerHTML = '';
          bouton.appendChild(document.createTextNode(ch.titre));
          var fleche = document.createElement('i');
          fleche.textContent = '↗';
          bouton.appendChild(fleche);
          bouton.addEventListener('click', function () {
            allerA(racine.querySelector('[data-ml-chapitre="' + ch.cle + '"]'));
          });
          li.appendChild(bouton);
          suiteListe.appendChild(li);
        });
        suite.hidden = false;
      }
    }
  }

  function suivreLecture() {
    var barre = $('[data-ml-progres]');
    var jauge = barre ? barre.querySelector('i') : null;
    var colonne = $('.ml-colonne');
    if (barre) barre.hidden = false;
    var enAttente = false;

    function mesurer() {
      enAttente = false;
      if (jauge && colonne) {
        var haut = colonne.getBoundingClientRect().top + window.pageYOffset;
        var course = colonne.offsetHeight - window.innerHeight * 0.7;
        var fait = window.pageYOffset - haut;
        var part = course > 0 ? Math.min(1, Math.max(0, fait / course)) : 0;
        jauge.style.width = (part * 100).toFixed(1) + '%';
      }
      var actif = null;
      chapitresVisibles().forEach(function (ch) {
        var el = racine.querySelector('[data-ml-chapitre="' + ch.cle + '"]');
        if (el && el.getBoundingClientRect().top <= window.innerHeight * 0.4) actif = ch.cle;
      });
      $$('[data-ml-nav]').forEach(function (li) {
        li.classList.toggle('est-active', li.getAttribute('data-ml-nav') === actif);
      });
    }

    function planifier() {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(mesurer);
    }

    window.addEventListener('scroll', planifier, { passive: true });
    window.addEventListener('resize', planifier);
    mesurer();
  }

  // ------------------------------------------------------- la lecture
  function remplir(data) {
    texte($('[data-ml-prenom]'), data.prenom || '');
    texte($('[data-ml-formule]'), data.formule || '');

    var zoneQuestion = $('[data-ml-question]');
    if (zoneQuestion) {
      if (rempli(data.question)) {
        texte(zoneQuestion.querySelector('[data-ml-question-texte]'), data.question);
      } else {
        zoneQuestion.hidden = true;
      }
    }

    paragraphes($('[data-ml-ouverture]'), data.ouverture);
    paragraphes($('[data-ml-reponse]'), data.reponse);
    paragraphes($('[data-ml-conseil]'), data.conseil);

    poserCartes(data.cartes || []);
    poserMinis(data.cartes || []);
    poserFiches(data.cartes || []);

    var domaines = $('[data-ml-domaines-bloc]');
    if (domaines) {
      if (rempli(data.amour) || rempli(data.travail) || rempli(data.argent)) {
        paragraphes($('[data-ml-amour]'), data.amour);
        paragraphes($('[data-ml-travail]'), data.travail);
        paragraphes($('[data-ml-argent]'), data.argent);
        paragraphes($('[data-ml-guidance]'), data.guidance);
      } else {
        domaines.hidden = true;
      }
    }

    var rituel = $('[data-ml-rituel-bloc]');
    if (rituel) {
      if (rempli(data.rituel)) {
        texte($('[data-ml-rituel-titre]'), data.rituel_titre || 'Votre rituel');
        paragraphes($('[data-ml-rituel]'), data.rituel);
      } else {
        rituel.hidden = true;
      }
    }

    var pierre = $('[data-ml-pierre-bloc]');
    if (pierre) {
      if (rempli(data.pierre)) {
        texte($('[data-ml-pierre-nom]'), data.pierre);
        paragraphes($('[data-ml-pierre]'), data.pierre_texte);

        var cadre = $('[data-ml-pierre-visuel]');
        var image = $('[data-ml-pierre-image]');
        var urlPierre = (config.pierres && data.pierre_fichier)
          ? config.pierres.replace('__NOM__', data.pierre_fichier) : '';
        if (urlPierre && cadre && image) {
          image.src = urlPierre;
          image.alt = data.pierre;
          cadre.hidden = false;
        }

        // Sans visuel, la fiche doit repasser sur une colonne : sinon le texte et le
        // bouton tombent dans la colonne étroite prévue pour l'image.
        var braceletCadre = $('[data-ml-bracelet-visuel]');
        var braceletImage = $('[data-ml-bracelet-image]');
        var bracelet = $('.ml-bracelet');
        if (data.pierre_image && braceletCadre && braceletImage) {
          braceletImage.src = data.pierre_image;
          braceletImage.alt = 'Bracelet en ' + data.pierre;
          braceletCadre.hidden = false;
        } else if (bracelet) {
          bracelet.classList.add('sans-visuel');
        }
        texte($('[data-ml-bracelet-titre]'), 'La porter au quotidien');
        var lien = $('[data-ml-pierre-lien]');
        if (lien) {
          lien.href = data.pierre_url || config.boutique || '/';
          lien.textContent = 'Voir nos bracelets en ' + data.pierre;
        }
      } else {
        pierre.hidden = true;
      }
    }

    paragraphes($('[data-ml-cloture]'), data.cloture);
  }

  // ---------------------------------------------------------- démarrage
  var jeton = window.location.search.match(/[?&]c=([A-Za-z0-9_-]{8,64})/);
  if (!jeton) {
    montrer('erreur');
    return;
  }

  fetch((config.base || '') + 'lecture-' + jeton[1] + '.json', { cache: 'no-store' })
    .then(function (r) {
      if (!r.ok) throw new Error('statut ' + r.status);
      return r.json();
    })
    .then(function (data) {
      remplir(data);
      montrer('accueil');

      var bouton = $('[data-ml-action="retourner"]');
      if (bouton) {
        bouton.addEventListener('click', function () {
          bouton.disabled = true;
          retourner(function () {
            bouton.hidden = true;
            if (ecrans.lecture) ecrans.lecture.hidden = false;
            poserNavigation();
            suivreLecture();
            allerA($('[data-ml-chapitre="reponse"]'));
          });
        });
      }
      $$('[data-ml-action="imprimer"]').forEach(function (bouton) {
        bouton.addEventListener('click', function () { window.print(); });
      });
    })
    .catch(function () { montrer('erreur'); });
})();
